import React, { useEffect, useRef, useState } from "react";

const PROFILE_URL = "https://www.tiktok.com/@inkad.diegem";
const SCRIPT_ID = "tiktok-embed-script";

export const TikTokEmbed = ({ dark = false }) => {
  const hostRef = useRef(null);
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;

    setFailed(false);
    setLoaded(false);
    host.replaceChildren();

    const bq = document.createElement("blockquote");
    bq.className = "tiktok-embed";
    bq.cite = PROFILE_URL;
    bq.setAttribute("data-unique-id", "inkad.diegem");
    bq.setAttribute("data-embed-type", "creator");
    bq.style.cssText = "max-width:720px;min-width:288px;margin:0 auto;";
    const section = document.createElement("section");
    const a = document.createElement("a");
    a.href = PROFILE_URL;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.textContent = "@inkad.diegem op TikTok";
    section.appendChild(a);
    bq.appendChild(section);
    host.appendChild(bq);

    document.getElementById(SCRIPT_ID)?.remove();
    const s = document.createElement("script");
    s.id = SCRIPT_ID;
    s.async = true;
    s.src = `https://www.tiktok.com/embed.js?t=${Date.now()}`;
    s.onerror = () => setFailed(true);
    document.body.appendChild(s);

    // Poll of de embed effectief een iframe rendert; zo niet -> fallback tonen
    let elapsed = 0;
    const poll = setInterval(() => {
      elapsed += 500;
      if (host.querySelector("iframe")) {
        setLoaded(true);
        clearInterval(poll);
      } else if (elapsed >= 8000) {
        setFailed(true);
        clearInterval(poll);
      }
    }, 500);

    return () => {
      clearInterval(poll);
      host.replaceChildren();
    };
  }, []);

  return (
    <div data-testid="jeugd-tiktok-embed">
      <div ref={hostRef} className="flex min-h-[200px] justify-center overflow-x-auto" style={{ display: failed ? "none" : "flex" }} />
      {!loaded && !failed && (
        <p className={`text-center text-sm ${dark ? "text-white/50" : "text-[#52525B]/70"}`} data-testid="jeugd-tiktok-loading">
          TikTok laden…
        </p>
      )}
      {failed && (
        <a
          href={PROFILE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="jeugd-tiktok-fallback"
          className="group flex flex-col items-center justify-center gap-4 rounded-2xl border border-dashed p-10 text-center transition-colors"
          style={{ borderColor: dark ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.15)" }}
        >
          <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#262626] text-white">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" /></svg>
          </span>
          <span className={`font-semibold ${dark ? "text-white" : "text-[#262626]"}`}>Bekijk onze video's op TikTok</span>
          <span className="text-sm text-[#E07A5F] underline">@inkad.diegem</span>
        </a>
      )}
    </div>
  );
};
